module.exports = __webpack_public_path__ + "static/media/cheesecake.fd8e1776.JPG";